import { useLocalization } from "../../../features/localization/index.js";
import { createElementBlock, createElementVNode, defineComponent, normalizeClass, openBlock, toDisplayString, unref, withModifiers } from "vue";
//#region src/v2/blocks/response-block/components/ResponseBodyToggle.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { class: "text-c-3 text-xxs -my-1 flex justify-center gap-0.5 rounded p-0.5" };
var ResponseBodyToggle_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ResponseBodyToggle",
	props: { modelValue: { type: Boolean } },
	emits: ["update:modelValue"],
	setup(__props) {
		const { translate } = useLocalization();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("button", {
				class: normalizeClass(["hover:bg-b-3 rounded px-1", { "bg-b-3 text-c-1 cursor-default": __props.modelValue }]),
				type: "button",
				onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("update:modelValue", true), ["stop"]))
			}, toDisplayString(unref(translate)("apiClient.responseBodyToggle.preview")), 3), createElementVNode("button", {
				class: normalizeClass(["hover:bg-b-3 rounded px-1", { "bg-b-3 text-c-1 cursor-default": !__props.modelValue }]),
				type: "button",
				onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("update:modelValue", false), ["stop"]))
			}, toDisplayString(unref(translate)("apiClient.responseBodyToggle.raw")), 3)]);
		};
	}
});
//#endregion
export { ResponseBodyToggle_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ResponseBodyToggle.vue.script.js.map